import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex';
import SidebarItem from './SidebarItem';
import _variables from '@/assets/styles/variables.scss';
import Logo from './Logo';
export default {
  components: {
    SidebarItem: SidebarItem,
    Logo: Logo
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters(['sidebar'])), mapState({
    leftDays: function leftDays(state) {
      return state.user.company_info.left_days;
    }
  })), {}, {
    routes: function routes() {
      var routes = this.$store.getters.routes;
      // 根据是否过期判断是否有dashboard路由
      if (!this.leftDays) {
        routes.forEach(function (item) {
          if (item.path === '/') item.children = [];
        });
      }
      return routes;
    },
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
        path = route.path;
      // if set path, the sidebar will highlight the path you set
      return meta.type || path;
    },
    showLogo: function showLogo() {
      return true;
    },
    variables: function variables() {
      return _variables;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  })
};